// BULK Trader Revamp

import { Card } from '@ovComponents/2-component/card/card';
import BulkTradersTable from '@ovComponents/4-module/bulkTrader/bulkTraders/components/bulkTradersTable';

const BulkTradersRevamp = () => (
  <Card variant='elevated' sx={{ width: '100%' }}>
    <BulkTradersTable />
  </Card>
);

export default BulkTradersRevamp;
